// extracted by mini-css-extract-plugin
export var iconWrapper = "person-module--icon-wrapper--rDeJD";
export var image = "person-module--image--GpQqP";
export var infoWrapper = "person-module--info-wrapper--E2KxS";
export var nameText = "person-module--name-text--sD5CT";
export var wrapper = "person-module--wrapper--xFsQ9";